module.exports = __webpack_public_path__ + "img/chinaTaiping.8a1a45a8.png";